import React, { useState, useEffect } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import {
    CircularProgressbar,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../../../utils/AnimatedProgressProvider";

import { Link, useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

import PhoneInput, { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input'

import 'react-international-phone/style.css';
import { useDispatch, useSelector } from 'react-redux'
import { getCityData, getCountryData, getProfileData, getStateData } from '../../../Redux/action/MasterAction';
import Beatloader from '../../../Common/BeatLoader';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';

const host = process.env.REACT_APP_API_SERVER

const TutorProfileBankDetails = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authToken = localStorage.getItem('tutor-token');
    useEffect(() => {
        dispatch(getProfileData(authToken))
    }, []);

    const {
        loadingProfileDataListApi,
        ProfileDataListApiData,
        ProfileDataListApiError,

    } = useSelector(state => state?.MasterReducer);




    const [countryType, setCountryType] = useState("india");


    let [initialValues] = useState({
        account_holder: "",
        account_number: "",
        bank_name: "",
        bank_address: "",

        ifsc_code: "",
        swift_code: "",
        routing_no: "",
        wire_transfer_no: "",
    });

    const InfoIcon = ({ text }) => (
        <OverlayTrigger placement="right" overlay={<Tooltip>{text}</Tooltip>}>
            <i
                className="fa fa-info-circle ms-2 text-primary"
                style={{ cursor: "pointer" }}
            />
        </OverlayTrigger>
    );

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            account_holder: Yup.string().required("Account holder name required"),
            account_number: Yup.string().required("Account number required"),
            bank_name: Yup.string().required("Bank name required"),
            bank_address: Yup.string().required("Bank address required"),

            ifsc_code: Yup.string().test(
                "ifsc-required",
                "IFSC code required",
                function (value) {
                    return countryType !== "india" || !!value;
                }
            ),


            swift_code: Yup.string().test(
                "swift-required",
                "SWIFT / BIC required",
                value => {
                    if (countryType === "india" || countryType === "other") {
                        return !!value;
                    }
                    return true;
                }
            ),

            routing_no: Yup.string().test(
                "routing-required",
                "Routing number required",
                value => {
                    if (countryType === "us") {
                        return !!value;
                    }
                    return true;
                }
            ),

            wire_transfer_no: Yup.string().test(
                "wire-required",
                "Wire transfer number required",
                value => {
                    if (countryType === "other") {
                        return !!value;
                    }
                    return true;
                }
            ),

        }),

        onSubmit: (values, { setSubmitting }) => {
            try {
                setSubmitting(true);

                let payload = {
                    account_holder: values.account_holder,
                    account_number: values.account_number,
                    bank_name: values.bank_name,
                    bank_address: values.bank_address,
                    country_type: countryType,
                };

                if (countryType === "india") {
                    payload.ifsc_code = values.ifsc_code;
                    payload.swift_code = values.swift_code;
                }

                if (countryType === "us") {
                    payload.routing_no = values.routing_no;
                }

                if (countryType === "other") {
                    payload.swift_code = values.swift_code;
                    payload.wire_transfer_no = values.wire_transfer_no;
                }

                let config = {
                    headers: {
                        "x-auth-token": localStorage.getItem("tutor-token"),
                    },
                };

                axios
                    .post(`${host}/api/tutor/create-bank-details`, payload, config)
                    .then((res) => {
                        if (res.status === 200) {
                            toast.success("Bank details updated successfully");
                            dispatch(getProfileData(authToken));
                            navigate("/tutor/profile-settings", { state: { active: "bank" } });
                        } else {
                            toast.error(res.data.message);
                        }
                        setSubmitting(false);
                    })
                    .catch((err) => {
                        toast.error(err.response?.data?.message);
                        setSubmitting(false);
                    });
            } catch (error) {
                toast.error("Something went wrong");
                setSubmitting(false);
            }
        }

    });


    useEffect(() => {

        if (ProfileDataListApiData?.data?.tutorbankdetails) {
            const bankDetails = ProfileDataListApiData.data.tutorbankdetails;

            setCountryType(bankDetails.country_type || "india");

            formik.setValues({
                account_holder: bankDetails.account_holder ?? "",
                account_number: bankDetails.account_number ?? "",
                bank_name: bankDetails.bank_name ?? "",
                bank_address: bankDetails.bank_address ?? "",
                ifsc_code: bankDetails.ifsc_code ?? "",
                swift_code: bankDetails.swift_code ?? "",
                routing_no: bankDetails.routing_no ?? "",
                wire_transfer_no: bankDetails.wire_transfer_no ?? "",
            });
        }

    }, [ProfileDataListApiData?.data])


    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Profile
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">

                            <main className="px-3 py-4">
                                <div className="student-profile-sec px-3">
                                    <div className="row mb-5">


                                    </div>
                                </div>
                                <ul className="nav nav-tabs tutor-profile-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link "
                                            id="personal-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#personal"
                                            type="button"
                                            role="tab"
                                            aria-controls="personal"
                                            aria-selected="false"
                                        >
                                            <i className="fa-regular fa-user" /> Personal Information
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="bank-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#bank"
                                            type="button"
                                            role="tab"
                                            aria-controls="bank"
                                            aria-selected="true"
                                        >
                                            <i className="fa-solid fa-building-columns" /> Bank Details
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="price-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#price"
                                            type="button"
                                            role="tab"
                                            aria-controls="price"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-tag" /> Updated Tutoring Price
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="tutor-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#tutor"
                                            type="button"
                                            role="tab"
                                            aria-controls="tutor"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-vcard-fill" /> Tutor Teaching List
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="cip-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#cip"
                                            type="button"
                                            role="tab"
                                            aria-controls="cip"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-fill-check" /> CIP Details
                                        </button>
                                    </li>
                                </ul>
                                <div
                                    className="tab-content"
                                    id="myTabContent"
                                    style={{ backgroundColor: "aliceblue" }}
                                >
                                    {/* Personal Information */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="personal"
                                        role="tabpanel"
                                        aria-labelledby="personal-tab"
                                    >
                                        <form>
                                            <div className="d-flex justify-content-between my-4">
                                                <h5>Personal Information</h5>
                                                <Link
                                                    to="/tutor/profile-settings-personal-info"
                                                    className="btn btn-primary edit-btn"
                                                >
                                                    <i className="bi bi-pencil-square" />
                                                    &nbsp;Edit
                                                </Link>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 w-100 d-flex justify-content-center pt-5">
                                                    <div className="profile-top-sec w-50">
                                                        <div className="profile-top-img d-flex justify-content-center">
                                                            <OverlayTrigger

                                                                placement='right'
                                                                overlay={
                                                                    <Tooltip className='bg-light'>
                                                                        {ProfileDataListApiData?.profile_status_percentage}%
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="img-sec position-relative">
                                                                    {/* Circular Progress Bar */}
                                                                    <AnimatedProgressProvider
                                                                        valueStart={0}
                                                                        valueEnd={ProfileDataListApiData?.profile_status_percentage}
                                                                        duration={1.4}
                                                                        easingFunction={easeQuadInOut}

                                                                    >
                                                                        {value => {
                                                                            const roundedValue = Math.round(value);
                                                                            return (
                                                                                <CircularProgressbar
                                                                                    value={value}

                                                                                    /* This is important to include, because if you're fully managing the
                                                                              animation yourself, you'll want to disable the CSS animation. */
                                                                                    styles={buildStyles({ pathTransition: "none" })}
                                                                                />
                                                                            );
                                                                        }}
                                                                    </AnimatedProgressProvider>
                                                                    {/* Profile Image */}
                                                                    <img
                                                                        src={`${host}${ProfileDataListApiData?.data?.profile_img}`}

                                                                        onError={(e) => {
                                                                            e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                        }}
                                                                        className="profile-img"
                                                                    />
                                                                </div>
                                                            </OverlayTrigger>
                                                        </div>
                                                        <h4 className="text-center mt-3">{ProfileDataListApiData?.data?.name}</h4>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Full Name
                                                    </label>


                                                    <p className=" input-form bg-white">{ProfileDataListApiData?.data?.name}</p>

                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Phone Number
                                                    </label>
                                                    <p className=" input-form bg-white">
                                                        {ProfileDataListApiData?.data?.country_code} {ProfileDataListApiData?.data?.mobile}

                                                    </p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Email ID
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.email}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Date of Birth
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.dob}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Gender
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.gender}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Address Line-1
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.address_line_1}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Address Line-2
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.address_line_2}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Country
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.countries?.name}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        State
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.states?.name}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        City
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.cities?.name}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Zip code
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.zip_code}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Qualification
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.qualifications}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Specialization
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.specialization}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Experience in years
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.experience}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Tutoring location
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.tutoring_location}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Session Price One to One
                                                    </label>
                                                    <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Session Price Group
                                                    </label>
                                                    <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Instructor Language
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.language}</p>
                                                </div>
                                                <div className="col-lg-12 col-md-12">
                                                    <label htmlFor="" className="label">
                                                        About the tutor
                                                    </label>

                                                    <textarea
                                                        className="input-form w-100 rounded"
                                                        readOnly
                                                        defaultValue={ProfileDataListApiData?.data?.tutordetails?.about_the_tutor}
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    {/* Bank Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade show active p-3"
                                        id="bank"
                                        role="tabpanel"
                                        aria-labelledby="bank-tab"
                                    >
                                        {loadingProfileDataListApi ? (
                                            <Beatloader />
                                        ) : (
                                            <form onSubmit={formik.handleSubmit}>

                                                <div className="d-flex justify-content-between my-4">
                                                    <h5>Bank Details</h5>
                                                    
                                                </div>

                                                {/* Country Selection */}
                                                <div className="row mb-4">
                                                    <label className="label mb-2">
                                                        Select Country
        
                                                    </label>
                                                    <div className="d-flex gap-4">
                                                        {["india", "us", "other"].map((type) => (
                                                            <label key={type} className="d-flex align-items-center gap-2 cursor-pointer">
                                                                <input
                                                                    type="radio"
                                                                    name="country_type"
                                                                    checked={countryType === type}
                                                                    onChange={() => setCountryType(type)}
                                                                />
                                                                <span>
                                                                    {type === "india" && "India"}
                                                                    {type === "us" && "US"}
                                                                    {type === "other" && "Other"}
                                                                </span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="row">

                                                    {/* Account Holder */}
                                                    <div className="col-md-6 mb-3">
                                                        <label className="label">
                                                            Account Holder Name <span className="text-danger">*</span>
                                                           
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="account_holder"
                                                            className="input-form"
                                                            placeholder="Enter account holder name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.account_holder}
                                                        />
                                                        {formik.touched.account_holder && formik.errors.account_holder && (
                                                            <div className="text-danger">{formik.errors.account_holder}</div>
                                                        )}
                                                    </div>

                                                    {/* Account Number */}
                                                    <div className="col-md-6 mb-3">
                                                        <label className="label">
                                                            Account Number <span className="text-danger">*</span>
                                                            

                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="account_number"
                                                            className="input-form"
                                                            placeholder="Enter account number"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.account_number}
                                                        />
                                                        {formik.touched.account_number && formik.errors.account_number && (
                                                            <div className="text-danger">{formik.errors.account_number}</div>
                                                        )}
                                                    </div>

                                                    {/* Bank Name */}
                                                    <div className="col-md-6 mb-3">
                                                        <label className="label">
                                                            Bank Name <span className="text-danger">*</span>
                                                            
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="bank_name"
                                                            className="input-form"
                                                            placeholder="Enter bank name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.bank_name}
                                                        />
                                                        {formik.touched.bank_name && formik.errors.bank_name && (
                                                            <div className="text-danger">{formik.errors.bank_name}</div>
                                                        )}
                                                    </div>

                                                    {/* INDIA */}
                                                    {countryType === "india" && (
                                                        <>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="label">
                                                                    IFSC Code <span className="text-danger">*</span>
                                                                    <InfoIcon text="Enter IFSC code (Eg: SBIN0001234)." />
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    className="input-form"
                                                                    placeholder="Enter IFSC code"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.ifsc_code}
                                                                />
                                                                {formik.touched.ifsc_code && formik.errors.ifsc_code && (
                                                                    <div className="text-danger">{formik.errors.ifsc_code}</div>
                                                                )}
                                                            </div>

                                                            <div className="col-md-6 mb-3">
                                                                <label className="label">
                                                                    SWIFT / BIC Code <span className="text-danger">*</span>
                                                                   <InfoIcon text="Enter 8 or 11 character SWIFT/BIC code. Eg. HDFCINBB or HDFCINBBXXX" />

                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="swift_code"
                                                                    className="input-form"
                                                                    placeholder="Enter SWIFT / BIC code"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.swift_code}
                                                                />
                                                                {formik.touched.swift_code && formik.errors.swift_code && (
                                                                    <div className="text-danger">{formik.errors.swift_code}</div>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* US */}
                                                    {countryType === "us" && (
                                                        <div className="col-md-6 mb-3">
                                                            <label className="label">
                                                                Routing Number (ACH / ABA) <span className="text-danger">*</span>
                                                                <InfoIcon text="Enter 9-digit ABA routing number. Numbers only. Eg. 021000021" />
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="routing_no"
                                                                className="input-form"
                                                                placeholder="Enter routing number"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.routing_no}
                                                            />
                                                            {formik.touched.routing_no && formik.errors.routing_no && (
                                                                <div className="text-danger">{formik.errors.routing_no}</div>
                                                            )}
                                                        </div>
                                                    )}

                                                    {/* OTHER */}
                                                    {countryType === "other" && (
                                                        <>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="label">
                                                                    SWIFT / BIC Code <span className="text-danger">*</span>
                                                                   <InfoIcon text="SWIFT/BIC code (8–11 characters). Eg. HDFCINBB" />
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="swift_code"
                                                                    className="input-form"
                                                                    placeholder="Enter SWIFT / BIC code"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.swift_code}
                                                                />
                                                                {formik.touched.swift_code && formik.errors.swift_code && (
                                                                    <div className="text-danger">{formik.errors.swift_code}</div>
                                                                )}
                                                            </div>

                                                            <div className="col-md-6 mb-3">
                                                                <label className="label">
                                                                    Wire Transfer Number <span className="text-danger">*</span>
                                                                   <InfoIcon text="Enter wire transfer number provided by your bank. Numbers only. Eg. 987654321" />
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="wire_transfer_no"
                                                                    className="input-form"
                                                                    placeholder="Enter wire transfer number"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.wire_transfer_no}
                                                                />
                                                                {formik.touched.wire_transfer_no && formik.errors.wire_transfer_no && (
                                                                    <div className="text-danger">{formik.errors.wire_transfer_no}</div>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* Bank Address */}
                                                    <div className="col-md-6 mb-3">
                                                        <label className="label">
                                                            Bank Address <span className="text-danger">*</span>
                                                            
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="bank_address"
                                                            className="input-form"
                                                            placeholder="Enter bank address"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.bank_address}
                                                        />
                                                        {formik.touched.bank_address && formik.errors.bank_address && (
                                                            <div className="text-danger">{formik.errors.bank_address}</div>
                                                        )}
                                                    </div>

                                                </div>

                                                <div className="row mt-4">
                                                    <div className="col-md-3">
                                                        <button disabled={formik.isSubmitting} type="submit" className="btn btn-primary w-100">
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>

                                            </form>
                                        )}
                                    </div>


                                    {/* Updated Tutoring Price */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="price"
                                        role="tabpanel"
                                        aria-labelledby="price-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Updated Tutoring Price</h5>
                                            <Link
                                                to="/tutor/profile-settings-updated-tutoring-price"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price One To One<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price Group<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Tutor Teaching List */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="tutor"
                                        role="tabpanel"
                                        aria-labelledby="tutor-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Tutor Teaching List</h5>
                                            <Link
                                                to="/tutor/profile-settings-tutor-teaching-list"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            {ProfileDataListApiData?.data?.tutorteachingdetails?.map((data) => (
                                                <div className="col-lg-6 col-md-6 mb-4">
                                                    <div className="tutor-teaching-list">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 d-flex align-item-center flex-wrap">
                                                                <div
                                                                    className="initial-circle"
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        backgroundColor: '#f0f0f0',
                                                                        color: '#333',
                                                                        fontSize: '24px',
                                                                        fontWeight: 'bold',
                                                                        borderRadius: '50%',
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        textTransform: 'uppercase',
                                                                    }}
                                                                >
                                                                    {data?.sub_category?.name?.charAt(0) || '-'}
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-5 pt-3">
                                                                <h6 className=" tutor-teaching-list-h6">{data?.category?.other_name ? data?.category?.other_name : data?.category?.name}</h6>
                                                                <p className=" tutor-teaching-list-eco mt-1">{data?.sub_category?.other_name ? data?.sub_category?.other_name : data?.sub_category?.name}</p>
                                                                <p className=" tutor-teaching-list-group ">{data?.teaching_type_id ? 'Group' : 'One To One'}</p>
                                                            </div>
                                                            <div className="col-lg-3 col-md-4">
                                                                <p className=" tutor-teaching-list-approve">{data?.status}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-6 mb-3">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    id="submit-btn-four"
                                                    className="btn btn-primary input-form-submit submit-btn w-100"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-6 mb-3">
                                                <button
                                                    type="button"
                                                    id="add-btn"
                                                    className="btn btn-primary w-100"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                    style={{ display: "none" }}
                                                >
                                                    <i className="fa-solid fa-plus" />
                                                    &nbsp;Add
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Cip Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="cip"
                                        role="tabpanel"
                                        aria-labelledby="cip-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>CIP (Customer Identification Program)</h5>
                                            <Link
                                                to="/tutor/profile-settings-cip"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload educational document image</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.educational_degree &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.educational_degree}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload certificate image</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.certification &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.certification}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload any valid Govt ID proof</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.kyc_document &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.kyc_document}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-12">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    className="btn btn-primary input-form-submit submit-btn w-100"
                                                    id="submit-btn-five"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorProfileBankDetails